"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOAD_CONFIG = void 0;
const constants_1 = require("../../../core/script/constants");
exports.LOAD_CONFIG = { order: constants_1.OrderConfig.BOTTOM, sync: constants_1.SyncConfig.DEFAULT };
//# sourceMappingURL=constants.js.map